<template>
  <div class="outerbox formTable">
    <div class="innercoreversion formTableconten">
      <div><img width="367px" src="../image/newtitle.png" alt="" /></div>
      <div class="inputbox">
        <el-input placeholder="请输入姓名" v-model="form.inputname">
          <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i>
            -->
          <div slot="prefix" class="imgboxbiao">
            <img src="../image/proper.png" width="20px" height="20px" alt="" />
          </div>
        </el-input>
        <el-input placeholder="电话" maxlength="11" v-model="form.inputnumber">
          <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i>
            -->
          <div slot="prefix" class="imgboxbiao">
            <img src="../image/shoujihao.png" width="20px" height="20px" alt="" />
          </div>
        </el-input>
        <el-input placeholder="所在城市" v-model="form.inputcity">
          <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i>
            -->
          <div slot="prefix" class="imgboxbiao">
            <img src="../image/suozaichengshi.png" width="20px" height="20px" alt="" />
          </div>
        </el-input>
        <!-- <el-input placeholder="申请功能" v-model="inputfunction">
          <div slot="prefix" class="imgboxbiao">
            <img src="../image/gongneng.png" width="20px" height="20px" alt="" />
          </div>
        </el-input> -->
        <el-select v-model="form.inputfunction" multiple placeholder="申请功能">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          <div slot="prefix" class="imgboxbiao">
            <img src="../image/gongneng.png" width="20px" height="20px" alt="" />
          </div>
        </el-select>
        <el-input placeholder="所属行业" v-model="form.inputindustry">
          <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i>
            -->
          <div slot="prefix" class="imgboxbiao">
            <img src="../image/suoshuhangye.png" width="20px" height="20px" alt="" />
          </div>
        </el-input>
        <el-input placeholder="门店类型" v-model="form.inputtype">
          <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i>
            -->
          <div slot="prefix" class="imgboxbiao">
            <img src="../image/mendian.png" width="20px" height="20px" alt="" />
          </div>
        </el-input>
      </div>
      <div class="bouttonforme" @click="gohavenew">马上试用</div>
    </div>
  </div>
</template>
  
  <script>
import _ from 'lodash'
import { intention } from '@/api/companyapi.js'
export default {
  name: 'formTable',
  data() {
    return {
      form: {
        inputname: '',
        inputnumber: '',
        inputcity: '',
        inputfunction: '',
        inputindustry: '',
        inputtype: '',
      },
      options: [
        {
          value: '智能巡店',
          label: '智能巡店',
        },
        {
          value: '智能营建',
          label: '智能营建',
        },
        {
          value: 'AI场景搭建',
          label: 'AI场景搭建',
        },
      ],
    }
  },
  methods: {
    gohavenew: _.debounce(
      async function () {
        console.log('填写的数据', this.form)
        let isgo = this.judgefunction()
        if (isgo) {
          return
        }
        let data = {
          name: this.form.inputname,
          phone: this.form.inputnumber,
          city: this.form.inputcity,
          functions: this.form.inputfunction,
          enterprise: this.form.inputindustry,
          storeType: this.form.inputtype,
        }
        let res = await intention(data)

        if (res.status.code == 200) {
          console.log('测试看看是否走过来', res)
          this.$message({
            message: '稍后将有亿大师工作人员联系！',
            type: 'success',
          })
        } else {
          this.$message(`${res.status.msg}`)
          console.log('15151', res)
        }
      },
      2000,
      { leading: true, trailing: false }
    ),
    judgefunction() {
      console.log('是否走到这个地方')
      if (!this.form.inputname) {
        this.$message(`请填写姓名`)
        return true
      }
      const phoneNumberPattern = /^1[3456789]\d{9}$/
      if (!phoneNumberPattern.test(this.form.inputnumber)) {
        this.$message(`请输入正确的电话号码`)
        return true
      }
      if (!this.form.inputcity) {
        this.$message(`请填写城市`)
        return true
      }
      if (!(this.form.inputfunction && this.form.inputfunction.length)) {
        this.$message(`请填写申请功能`)
        return true
      }
      if (!this.form.inputindustry) {
        this.$message(`请填写所属行业`)
        return true
      }
      if (!this.form.inputtype) {
        this.$message(`请填写门店类型`)
        return true
      }
      return false
    },
  },
}
</script>
  
  <style lang="less" scoped>
.formTable {
  height: 508px;
  .formTableconten {
    height: 100%;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .bouttonforme {
      width: 225px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      background: #57cc9a;
      border-radius: 34px 34px 34px 34px;
    }
    .inputbox {
      margin: 24px 0;
      display: grid;
      grid-template-columns: repeat(3, 1fr); /* 三列，每列宽度相等 */
      gap: 24px;
    }
  }
}
.imgboxbiao {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 13px;
}
/deep/ .el-input__inner {
  width: 384px;
  height: 60px;
  background: #f5f5f5;
  border: none;
  border-radius: 34px;
  padding-left: 48px;
}
/deep/ .el-input__inner::placeholder {
  color: rgba(101, 101, 101, 1); /* 设置为你想要的颜色 */
}
/deep/ .el-select .el-input__suffix {
  display: none;
}
/deep/ .el-select__tags {
  left: 10%;
}
/deep/ .el-message {
  z-index: 9999999; /* 根据需求设置更高的值 */
}
</style>